<template>
  <el-dialog
    :visible="visible"
    :title="dialogTitle"
    width="600px"
    class="combo-dialog"
    @opened="afterOpen"
    @close="onClose"
  >
    <div class="scroll-wrap">
      <el-form ref="form" :model="form" label-width="120px">
        <el-form-item
          label="属性类别"
          prop="groupCode"
          :rules="[{ required: true, message: '属性类别不能为空' }]"
        >
          <el-select
            v-model="form.groupCode"
            placeholder="请选择"
            size="small"
            :rules="[{ required: true, message: '属性类别不能为空' }]"
            style="width: 320px"
            :disabled="mode === 'edit'"
          >
            <el-option
              v-for="item in goodsGroupCodeList"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="属性值"
          prop="attrName"
          :rules="[{ required: true, message: '属性值不能为空' }]"
        >
          <el-input
            v-model="form.attrName"
            size="small"
            placeholder="请输入"
            style="width: 320px"
          />
        </el-form-item>
        <el-form-item
          label="权重"
          prop="weight"
          :rules="[{ required: true, message: '权重不能为空' }]"
        >
          <el-input-number
            v-model="form.weight"
            size="small"
            placeholder="请输入"
            style="width: 320px"
          />
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取 消</el-button>
      <el-button type="primary" @click="onSubmit">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import {
  GoodsGroupCodeToTextMap,
  GoodsTypeToGoodsGroupCodeMap,
} from "@/enum/dict/index.js";
import { addGoodsAttr, editGoodsAttr } from "./api.js";

export default {
  name: "GoodsAttrDetail",
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    id: {
      type: [Number, String],
      required: false,
      default: null,
    },
    mode: {
      type: String,
      required: true,
      validator: (value) => ["create", "edit"].includes(value),
    },
    goodsType: {
      type: Number,
      required: false,
      default: null,
    },
    groupCode: {
      type: String,
      required: false,
      default: null,
    },
    attrName: {
      type: String,
      required: false,
      default: null,
    },
    weight: {
      type: Number,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      form: {
        id: null,
        groupCode: undefined,
        attrName: undefined,
        weight: undefined,
      },
    };
  },
  computed: {
    dialogTitle() {
      switch (this.mode) {
        case "create":
          return "新增商品属性";
        case "edit":
          return "编辑商品属性";
        default:
          return "";
      }
    },
    goodsGroupCodeList() {
      return (GoodsTypeToGoodsGroupCodeMap.get(this.goodsType) ?? []).map(
        (goodsType) => {
          return {
            name: GoodsGroupCodeToTextMap.get(goodsType),
            value: goodsType,
          };
        },
      );
    },
  },
  methods: {
    async afterOpen() {
      if (this.mode === "create") {
        this.$refs.form.resetFields();

        this.$set(this, "form", this.$options.data().form);
        return;
      }

      this.form.id = this.id;
      this.form.groupCode = this.groupCode;
      this.form.attrName = this.attrName;
      this.form.weight = this.weight;
    },
    onClose() {
      this.$emit("update:visible", false);
    },
    async onSubmit() {
      const valid = await this.$refs.form.validate();

      if (!valid) {
        return;
      }

      if (this.form.id) {
        await editGoodsAttr({
          ...this.form,
          goodsType: this.goodsType,
        });
      } else {
        await addGoodsAttr({
          ...this.form,
          goodsType: this.goodsType,
        });
      }

      this.$message({
        type: "success",
        message: "操作成功",
      });

      this.onClose();

      this.$emit("refreshList");
    },
  },
};
</script>
<style scoped lang="scss">
.combo-dialog {
  /deep/ .el-form-item__label {
    font-weight: bold;
  }
}

.scroll-wrap {
  max-height: 70vh;
  overflow-y: auto;
}

.combo-form-item {
  width: 300px;

  /deep/ input {
    text-align: left;
  }
}

.repay-wrap {
  .repay-title {
    width: 120px;
    line-height: 40px;
    padding-right: 12px;
    text-align: right;
    font-weight: bold;
  }

  .repay-form {
    padding: 0 50px;
  }

  .repay-form-item {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #ddd;
    padding: 14px 0;

    /deep/ .el-form-item {
      margin: 0;
    }

    &:first-child {
      border-top: 1px solid #ddd;
    }
  }
}
</style>
